import React from 'react';
import { TolgeeProvider } from '@tolgee/react';
import { getTolgeeInstance } from './tolgee-config';
import { RTLHandler } from '../../components/RTLHandler';

type TolgeeAppProviderProps = {
  children: React.ReactNode;
  locale?: string;
};

export const TolgeeAppProvider = ({ 
  children, 
  locale = 'es' 
}: TolgeeAppProviderProps) => {
  // Inicializamos Tolgee con el idioma ya configurado
  const tolgee = React.useMemo(() => {
    console.log('🔧 [TolgeeAppProvider] Inicializando con locale:', locale);
    const instance = getTolgeeInstance();
    
    // Solo establecer idioma en el cliente
    if (typeof window !== 'undefined' && locale) {
      try {
        instance.changeLanguage(locale);
        console.log('🔧 [TolgeeAppProvider] Idioma establecido:', locale);
      } catch (error) {
        console.error('Error setting language in Tolgee:', error);
      }
    }
    
    return instance;
  }, [locale]); // Solo recreamos si cambia el locale

  // Siempre renderizar el TolgeeProvider para evitar errores de contexto
  return (
    <TolgeeProvider tolgee={tolgee}>
      <RTLHandler />
      {children}
    </TolgeeProvider>
  );
}; 